import { render, staticRenderFns } from "./DeviceFavorite.vue?vue&type=template&id=bd314de4&"
import script from "./DeviceFavorite.vue?vue&type=script&lang=js&"
export * from "./DeviceFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports